module.exports = __webpack_public_path__ + "img/kassa-3-topwise-t3-large.27583b45.png";